<template>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-full" role="alert">
          <h1 class="heading-xl">
            {{ $t('profileDeleted.heading') }}
          </h1>
          <p>{{ $t('profileDeleted.line1') }}</p>
          <p>{{ $t('profileDeleted.line2') }}</p>
        </div>
      </div>
      <div class="row row-vertical-align-bottom">
        <div class="col-full">
          <button
            v-analytics:click="$EVENTS.CLOSE_BUTTON"
            class="uppercase fill"
            data-test="action-button"
            :aria-label="$t('button.close')"
            @click.prevent="buttonAction()">
            {{ $t('button.close') }}
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { ROUTES } from '@/constants'

export default {
  name: ROUTES.CONFIRM,
  methods: {
    buttonAction() {
      this.$router.replace({ name: ROUTES.ENTRY })
    }
  }
}
</script>
